
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import { ISongWithLive } from "../@types/interface.d";
import years from "../years";

interface DataType {
  songs: ISongWithLive[];
  sortCol: string;
  sortAsc: boolean;
  years: number[];
}

interface MethodType {
  init: () => void;
  sort: () => void;
}

interface ComputedType {
  sorted: ISongWithLive[];
}

export default Vue.extend({
  name: "songs",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): DataType {
    return {
      songs: [],
      sortCol: "id",
      sortAsc: true,
      years,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      fetch("/api/songs")
        .then(res => res.json())
        .then((data: ISongWithLive[]) => {
          this.songs = data;
        });
    },
    sort(col: string) {
      if (this.sortCol === col) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortCol = col;
        this.sortAsc = true;
      }
    },
  },
  computed: {
    sorted() {
      let list: ISongWithLive[] = this.songs.concat([]);
      switch (this.sortCol) {
        case "id":
          break;
        case "title":
          list = list.sort((a, b) => (a.song.name < b.song.name ? -1 : 1));
          break;
        case "lastLive":
          list = list.sort((a, b) => {
            if (!a.lastLive) {
              return -1;
            }
            if (!b.lastLive) {
              return 1;
            }
            const ak = a.lastLive.date + a.lastLive.title;
            const bk = b.lastLive.date + b.lastLive.title;
            return ak > bk ? -1 : 1;
          });
          break;
        default:
          list = list
            .filter(v => v.counts[this.sortCol])
            .sort((a, b) => {
              const ak = a.counts[this.sortCol] || 0;
              const bk = b.counts[this.sortCol] || 0;
              return bk - ak;
            });
          break;
      }
      return this.sortAsc ? list : list.reverse();
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
